import React, { FC } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor, { customEditorPlugins } from 'src/utils/CustomClassicEditor';
import './appeditor2.css'

type AppCustomEditor2PropsType = {
  value: string;
  onChangeData: (params: string) => void;
  placeholder?: string;
};


const AppCustomEditor2: FC<AppCustomEditor2PropsType> = ({ value, placeholder, onChangeData }) => {
  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        config={{
          plugins: customEditorPlugins,
          placeholder: placeholder,
          toolbar: [
            'bold',
            'italic',
            'bulletedList',
            'numberedList',
            'blockQuote',
          ],
          ui: {
            poweredBy: {
              label: 'Commurium',
              horizontalOffset: 0,
              position: 'border',
              side: 'left',
              verticalOffset: 0,
              forceVisible: true,
            },
          },
        }}
        onChange={(_, editor) => {
          onChangeData(editor.getData());
        }}
      />
    </div>
  );
};

export default AppCustomEditor2;
